import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const ToastVariant = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export type ToastVariantType = (typeof ToastVariant)[keyof typeof ToastVariant];

export type ToastProps = {
  id?: string;
  testId?: string;
  distinctId?: string;
  variant?: ToastVariantType;
  icon?: TUNDR_ICONS;
  message: string;
  description?: string;
  detail?: string;
  copyable?: boolean;
  closable?: boolean;
  elevated?: boolean;
  fullWidth?: boolean;
};
